import React, { Suspense, useState } from "react"
import Box from "@material-ui/core/Box"
import Card from "@material-ui/core/Card"

/** Layout */
import WithHeader from "layout/WithHeader"

/** Component */
import Loader from "components/Loader"
import Footer from "components/Forms/Footer/new"
import PageHeaderTitle from "components/PageHeaderTitle"
import Dialog from "components/Dialog"
import Form from "pages/Dashboard/Bookkeeping/components/AddPayment/Form"

/** Context */
import { CtxType } from "./Context"
import withContext from "./withContext"

export const refSubmit = React.createRef<HTMLDivElement>()

const CreateOwnerView: React.FC<CtxType> = ({
  openDialog,
  setOpenDialog,
  setShowPayment,
  submitting,
  paymentDetails,
  handleCreatePayment
}) => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [isFormValid, setFormValid] = useState(false)
  const pd = paymentDetails

  function handleNext() {
    refSubmit.current?.click()

    if (pd?.paymentType !== "3" && isFormValid) {
      handleCreatePayment()
    }
  }

  return (
    <>
      <WithHeader>
        <PageHeaderTitle
          title="Create New Payment"
          breadcrumbs="property management / bookkeeping / new payment"
          backAction={() => setShowPayment(false)}
        />
        <Card>
          <Box>
            <Suspense fallback={<Loader forContent />}>
              <Form setFormValid={setFormValid} />
            </Suspense>
          </Box>
          <Box margin="30px 0">
            <Footer
              handleNext={() => handleNext()}
              handleBack={null}
              handleCancel={() => setOpenDialog && setOpenDialog(true)}
              label={submitting ? "Submitting" : "Submit"}
              disabled={submitting}
            />
          </Box>
          <Dialog
            action={() => setShowPayment(false)}
            isOpen={openDialog}
            setOpen={setOpenDialog}
            actionLabel="OK"
            title=""
            message="Are you sure you want to cancel?"
          />
        </Card>
      </WithHeader>
    </>
  )
}

export default withContext(CreateOwnerView)
